module.exports = __webpack_public_path__ + "img/home.67d51ebf.png";